export const SectionCard = ({ id, title, icon: Icon, children, testId }) => {
  return (
    <section id={id} data-testid={testId} className="scroll-mt-24 rounded-lg border border-white/10 bg-eb-surface p-5">
      <div className="mb-4 flex items-center gap-2">
        {Icon && <Icon size={18} className="text-eb-accent" />}
        <h2 className="font-heading text-lg uppercase tracking-tight text-white">{title}</h2>
      </div>
      {children}
    </section>
  );
};
